import { theme } from "../../constants/StyledComponents";
import { useAppSelector } from "../../hooks/store.hook";
import { FontWeightEnum, CollaboratorInfo } from "../../types/AppTypes";
import { getInitials } from "../../utils/collaborators.utils";
import { findPracticeById } from "../../utils/orgFunctions.utils";
import {
  Avatar,
  AvatarDimensionsEnum,
  AvatarDirectionEnum,
} from "../core/Avatar/Avatar";
import { StyledAvatarLayout } from "../core/Avatar/Avatar.styled";
import { BodyTyp, CaptionsTyp } from "../Typography/Typography";
import { StyledCollaboratorItem } from "./CollaboratorItem.styled";

type CollaboratorItemProps = {
  collaboratorInfo: CollaboratorInfo;
  onClick?: (item: CollaboratorInfo) => void;
  disabled?: boolean;
};

export const CollaboratorItem = ({
  collaboratorInfo,
  onClick,
  disabled,
}: CollaboratorItemProps) => {
  const { orgSettings } = useAppSelector((state) => state.config);

  return (
    <StyledCollaboratorItem
      $hasOnClick={!!onClick}
      {...(onClick && { onClick: () => onClick(collaboratorInfo) })}
      $disabled={disabled}
    >
      <StyledAvatarLayout $direction={AvatarDirectionEnum.HORIZONTAL}>
        <Avatar
          variant={AvatarDimensionsEnum.SMALL}
          collaboratorId={collaboratorInfo.id}
          initials={getInitials(
            collaboratorInfo.name,
            collaboratorInfo.surname,
          )}
        />
        <div className="avatar-name-text">
          <BodyTyp
            fontWeight={FontWeightEnum.SEMIBOLD}
            variant="3"
            color={disabled ? theme.colors.grey_4 : theme.colors.black}
          >
            {`${collaboratorInfo.surname} ${collaboratorInfo.name}`}
          </BodyTyp>
          <CaptionsTyp
            fontWeight={FontWeightEnum.REGULAR}
            color={disabled ? theme.colors.grey_4 : theme.colors.black}
          >
            {findPracticeById(
              orgSettings.areaList.all,
              collaboratorInfo.practice,
            )?.name || ""}
          </CaptionsTyp>
        </div>
      </StyledAvatarLayout>
    </StyledCollaboratorItem>
  );
};
